import { render } from "./company_info_field.vue?vue&type=template&id=635376ab"
import script from "./company_info_field.vue?vue&type=script&lang=js"
export * from "./company_info_field.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/users/profile/info/Helpers/company_info_field.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "635376ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('635376ab', __exports__)) {
    console.log('reload')
    api.reload('635376ab', __exports__)
  }
  
  module.hot.accept("./company_info_field.vue?vue&type=template&id=635376ab", () => {
    console.log('re-render')
    api.rerender('635376ab', render)
  })

}


export default __exports__